import * as actionTypes from "./actionTypes"

const initialState: ArticleState = {
    articles: {
        title: "",
    }
}

const reducer = (
    state: ArticleState = initialState,
    action: ArticleAction
  ): ArticleState => {
    switch (action.type) {
        case actionTypes.ADD_ARTICLE: {
            const newArticle: IArticle = {
                title: action.article.toString(),
            }
            return {
                ...state,
                articles: newArticle,
            }
        }
        break;
        default : return {
            ...state,
        }
            
    }
    return state
  }
  
export default reducer